import config from '../config/environment';
import api from "../services/api";

// URL utility functions for handling domain-based URLs

// Get the current domain (protocol + hostname + port)
export const getCurrentDomain = () => {
  return window.location.origin;
};

// Get the API domain (backend server) using environment config
export const getApiDomain = () => {
  // Use the environment configuration for API URL
  const apiUrl = config.API_BASE_URL;

  // If it's a relative path (production), use current domain
  if (apiUrl.startsWith("/")) {
    return window.location.origin;
  }

  // If it's a full URL, extract the domain
  if (apiUrl.startsWith("http")) {
    return apiUrl.replace("/api", "");
  }

  // Fallback
  return window.location.origin;
};

// Generate full profile URL
export const getProfileUrl = (employeeCode) => {
  return `${getCurrentDomain()}/profile/${employeeCode}`;
};

// Generate full image URL
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;

  // If it's already a full URL, return as is
  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    return imagePath;
  }

  // Otherwise, prepend the API domain
  return `${getApiDomain()}${imagePath}`;
};

// Generate QR code URL for scanning
export const getQrCodeUrl = (employeeCode) => {
  return `${getCurrentDomain()}/profile/${employeeCode}`;
};

// Extract filename from QR code URL
const extractFilenameFromUrl = (qrCodeUrl) => {
  if (!qrCodeUrl) return null;

  // Extract filename from URL path
  const urlParts = qrCodeUrl.split("/");
  const filename = urlParts[urlParts.length - 1];

  // Validate filename format
  if (filename && filename.match(/^qr_[A-Z0-9]+\.png$/)) {
    return filename;
  }

  return null;
};

// Download QR code using the download endpoint (avoids CSP issues)
export const downloadQrCode = async (qrCodeUrl, employeeCode) => {
  try {
    console.log("📥 Downloading QR code:", { qrCodeUrl, employeeCode });

    // Extract filename from URL
    const filename = extractFilenameFromUrl(qrCodeUrl);

    if (!filename) {
      throw new Error("Invalid QR code URL format");
    }

    console.log("🔗 Using download endpoint for filename:", filename);

    // Use the download endpoint instead of direct fetch
    const response = await api.get(`/employee/download-qr/${filename}`, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    // Create download link
    const blob = new Blob([response.data], { type: "image/png" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;

    // Add to DOM, click, and cleanup
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    console.log("✅ QR code downloaded successfully");
    return true;
  } catch (error) {
    console.error("❌ Error downloading QR code:", error);

    // Show user-friendly error message
    let errorMessage = "Failed to download QR code";
    if (error.response?.status === 404) {
      errorMessage = "QR code file not found";
    } else if (error.response?.status === 400) {
      errorMessage = "Invalid QR code format";
    } else if (error.message) {
      errorMessage = error.message;
    }

    alert(errorMessage);
    return false;
  }
}; 